import { CheckCircle2, Loader2, Clock, ShieldCheck, XCircle, PauseCircle } from "lucide-react";

export const STEP_STATUS = {
  pending: { Icon: Clock, c: "#94A3B8", l: "Menunggu giliran" },
  running: { Icon: Loader2, c: "#8B5CF6", l: "Sedang dikerjakan", spin: true },
  waiting_approval: { Icon: ShieldCheck, c: "#F59E0B", l: "Menunggu persetujuan Anda" },
  completed: { Icon: CheckCircle2, c: "#10B981", l: "Selesai" },
  failed: { Icon: XCircle, c: "#EF4444", l: "Gagal" },
  paused: { Icon: PauseCircle, c: "#F97316", l: "Dijeda" },
};
